import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  CharterLoyaltyPointMultiplierFilters,
  CharterLoyaltyPointMultiplierUpdateRequestBody,
} from '~/components/Flights/Charter/charter.types';

import { fetchCharterLoyaltyPointMultipliers, updateCharterLoyaltyPointMultipliers } from '~/services/CharterService';

import { charterLoyaltyPointMultiplierQueryKeys } from './charterLoyaltyPointMultiplierQueryKeys';

export function useGetCharterLoyaltyPointMultipliers(filters: CharterLoyaltyPointMultiplierFilters | null) {
  return useQuery({
    queryKey: filters
      ? charterLoyaltyPointMultiplierQueryKeys.list(filters)
      : [...charterLoyaltyPointMultiplierQueryKeys.lists(), 'disabled'],
    queryFn: async () => {
      if (!filters) {
        return [];
      }
      return await fetchCharterLoyaltyPointMultipliers(filters);
    },
    enabled: Boolean(filters),
  });
}

export function useUpdateCharterLoyaltyPointMultipliers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CharterLoyaltyPointMultiplierUpdateRequestBody) => {
      return await updateCharterLoyaltyPointMultipliers(payload);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: charterLoyaltyPointMultiplierQueryKeys.all });
    },
  });
}
